import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { enumUtil } from '../../../utils/Enum';
import isNull from "../../../utils/NullChecking";
import { debounce } from "lodash";
const ModalFooter = (props) => {
  const API_URL = enumUtil.controller.Audit
  const { isSaved, handleSave, UpdatedBy, UpdatedDate, Key, Name, ID, mdBtn, IsEditAllowed, handleSaveUser, CreateUserDisable } = { ...props };
  const handleSaveRef = useRef(handleSave);

  // Update ref to latest handleSave whenever it changes
  useEffect(() => {
    handleSaveRef.current = handleSave;
  }, [handleSave]);

  // useEffect(() => {
  //   const handleAltS = (event) => {
  //     let key = event.key.toLowerCase();
  //     if (key === 's' && key === 'c') {
  //       event.preventDefault();
  //       event.stopPropagation();
  //       handleSaveRef.current();
  //     }
  //   };

  //   window.addEventListener('keydown', handleAltS);
  //   return () => window.removeEventListener('keydown', handleAltS);
  // }, []);

  const comboKeys = useRef([]); // ✅ Holds current key sequence
  const isInputFocused = () => {
    const activeElement = document.activeElement;
    return (
      activeElement.tagName === 'INPUT' ||
      activeElement.tagName === 'TEXTAREA' ||
      activeElement.tagName === 'SELECT' ||
      activeElement.isContentEditable
    );
  };
  const executeCombo = useCallback(
    debounce(() => {
      if (isInputFocused()) {
        comboKeys.current = [];
        return;
      }
      const sequence = comboKeys.current.join('+');
      if (sequence === 's+c') {
        handleSaveRef.current();
      }
      comboKeys.current = [];
    }, 500), [])

  useEffect(() => {
    const handleKeyDown = (event) => {
      // if (!event.altKey) return;
      if (isInputFocused()) {
        return;
      }
      const key = event.key.toLowerCase();
      comboKeys.current.push(key);
      executeCombo();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      executeCombo.cancel();
    };
  }, [executeCombo]);
  return (
    <>
      {Name !== "Staff" && (
        <div className={!isNull(ID)
          ? "d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-between"
          : "d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-end"}
        >
          {!isNull(ID) && (
            <div className="update-info gap-01">
              <p className="">Updated By/Date:</p>
              <p className="d-flex align-items-center gap-01">
                <span className="position-relative is-empty">
                  {UpdatedBy ? UpdatedBy + ", " : ""}
                </span>
                <span title={UpdatedDate ? UpdatedDate.split("T")[0] : "00/00/0000"} className="is-empty">
                  {UpdatedDate ? UpdatedDate.split("T")[0] : "00/00/0000"}
                </span>
                <span className="is-empty">
                  {UpdatedDate ? UpdatedDate.split("T")[1] : "00:00 PM"}
                </span>
              </p>
            </div>
          )}

          <div className="d-flex justify-content-center align-items-center gap-2">
            <button className="btn btn-outline px-10 h-100 dark-clr" onClick={isSaved}>Cancel</button>
            <button
              className={IsEditAllowed ? "btn btn-validate px-10 h-100" : "btn btn-validate px-10 h-100 disabled"}
              disabled={!IsEditAllowed}
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      )}

      {Name === "Staff" && (
        <div className={!isNull(ID)
          ? "d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-between"
          : "d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-end"}
        >
          {!isNull(ID) && (
            <div className="update-info gap-01 flex-shrink-0">
              <p className="">Updated By/Date:</p>
              <p className="d-flex align-items-center gap-01">
                <span className="position-relative is-empty">
                  {UpdatedBy ? UpdatedBy + ", " : ""}
                </span>
                <span title={UpdatedDate ? UpdatedDate.split("T")[0] : "00/00/0000"} className="is-empty">
                  {UpdatedDate ? UpdatedDate.split("T")[0] : "00/00/0000"}
                </span>
                <span className="is-empty">
                  {UpdatedDate ? UpdatedDate.split("T")[1] : "00:00 PM"}
                </span>
              </p>
            </div>
          )}
          <div className={`d-flex align-items-center ar_footer justify-content-between gap-2 ${isNull(ID) && 'w-100'}`}>
            <button className="btn btn-outline px-10 h-100 dark-clr" onClick={isSaved}>Cancel</button>
            <div className="btns-group d-flex justify-content-center align-items-center gap-2">
              <button className={IsEditAllowed ? "btn btn-outline px-10 h-100 validate-color" : "btn btn-outline px-10 h-100 validate-color disabled"} onClick={handleSaveUser} disabled={CreateUserDisable === 'true' ? true : false}>Save & Create User</button>
              <button className={IsEditAllowed ? "btn btn-validate px-10 h-100 m-0" : "btn btn-validate px-10 h-100 disabled m-0"} onClick={handleSave}>Save</button>
            </div>
          </div>
        </div>
      )}
    </>
  );

};

export default React.memo(ModalFooter);

// import React,{ useEffect, useMemo, useState } from "react";
// import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
// import { enumUtil } from '../../../utils/Enum';
// import isNull from "../../../utils/NullChecking";

// const ModalFooter = (props) => {
//   const API_URL = enumUtil.controller.Audit
//   const { isSaved, handleSave, ParentID, TableName, Key, Name } = { ...props };
//   const [ data, setData]= useState({})
//   const LoadData = () => {
//     if(!isNull(ParentID)){
//       ServerRequestProtected(API_URL + "/FindAuditDateWise", 'post', {
//           "ID" : ParentID,
//           "TableName": TableName,
//           "SearchParam": ''
//       }).then((response) => {
//         console.log(response.AuditDetails[0])
//         setData(response.AuditDetails[0])
//       }).catch((error) => {
//         console.log(error);
//       })
//     }
//   }
//   useEffect(() => {
//     LoadData();
//   },[ParentID])
//   return (
//     <div className="btns-group text-end px-3 py-3 br-top-1 br-clr justify-content-between">
//       <p className="update-info">
//         Recent Updated By: <span>{!isNull(data.AuditBy) ? data.AuditBy : 'Yawar Ali'}</span>{'\u00A0\u00A0'}|{'\u00A0\u00A0'}
//         Date &amp; Time:{'\u00A0\u00A0'}<span>{data.AuditDate && !isNull(data.AuditDate.split(" ")[0]) ? data.AuditDate.split(" ")[0] : '00/00/0000'}</span>{'\u00A0\u00A0'}|{'\u00A0\u00A0'}
//         <span>{data.AuditDate && data.AuditDate.split(" ")[1]?data.AuditDate.split(" ")[1]:'00:00 PM'}</span>
//       </p>
//       <div className="btns-group">
//         <button className="btn btn-gray" onClick={isSaved}>
//           Cancel
//         </button>
//         <button className="btn btn-orange" onClick={handleSave}>
//           Save
//         </button>
//       </div>
//     </div>
//   );
// };

// export default React.memo(ModalFooter);

